document.addEventListener('DOMContentLoaded', function() {
    const titles = document.querySelectorAll('.homepage-hero-zone .h1');

    titles.forEach(title => {
        splitLinesClean(title);
    });

    function splitLinesClean(container) {
        const originalHTML = container.innerHTML;

        // STEP 1 — Split by <br>
        const brBlocks = originalHTML.split(/<br\s*\/?>/i);

        let finalResult = '';

        brBlocks.forEach(block => {
            if (!block.trim()) {return;}

            // Temporary container for processing each BR block separately
            const temp = document.createElement('div');
            temp.innerHTML = block;

            wrapVisualLines(temp); // process this block

            finalResult += temp.innerHTML; // add processed block
        });

        container.innerHTML = finalResult;
    }

    // STEP 2 — Your existing visual line-split logic (unchanged)
    function wrapVisualLines(container) {
        const tempHTML = container.innerHTML.replace(/(?![^<]*>)(\S+|\s+)/g, match => {
            return /<|>/.test(match) ? match : `<n>${match}</n>`;
        });

        container.innerHTML = tempHTML;

        const elements = Array.from(container.querySelectorAll('n, span, strong, em, b, i'));
        let top = null;
        let currentLine = '';
        let result = '';

        elements.forEach(node => {
            const rect = node.getBoundingClientRect();
            if (top === null) {top = rect.top;}

            if (rect.top > top + 1) {
                result += `<div class="line-wrap"><div class="line">${currentLine.trim()}</div></div>`;
                currentLine = '';
                top = rect.top;
            }

            currentLine += node.outerHTML || node.textContent;
        });

        if (currentLine.trim()) {
            result += `<div class="line-wrap"><div class="line">${currentLine.trim()}</div></div>`;
        }

        result = result.replace(/<\/?n>/g, '');
        container.innerHTML = result;
    }

    // animation for line wrap
    const hero = document.querySelector('.homepage-hero-zone');
    if (!hero) {return;}

    const lines = hero.querySelectorAll('.line-wrap .line');
    const desc = hero.querySelector('.hhz-desc');
    const link = hero.querySelector('.hhz-link');

    if (lines.length > 0) {
        const delayStep = 0.5; // same as SCSS
        const lastLineDelay = lines.length * delayStep;

        // dynamic delays
        if (desc) {
            desc.style.transitionDelay = `${lastLineDelay + 0.3}s`;
        }
        if (link) {
            link.style.transitionDelay = `${lastLineDelay + 0.6}s`;
        }
    }
});
